import { render, staticRenderFns } from "./CustomOffers.vue?vue&type=template&id=5878c3e1"
import script from "./CustomOffers.vue?vue&type=script&lang=js"
export * from "./CustomOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports